export const DEFAULT_ORDERS_PER_PAGE = 10;
export const TAB_BUCKET_ORDERS_FACET_NAME = "tabbuckettl";
export const DEFAULT_ORDERS_TAB_BUCKET_FILTERS = [
  "OpenOrder",
  "OtherOrder",
  "OtherOrder,AcceptedQuote",
  "OpenOrder,AcceptedQuote",
];
export const DEFAULT_QUOTES_TAB_BUCKET_FILTERS = [
  "OpenQuote",
  "ExpiredQuote",
  "OtherOrder,AcceptedQuote",
  "OpenOrder,AcceptedQuote",
];
export const DEFAULT_ORDERS_TAB_IDS = ["allOrders", "openOrders", "acceptedQuotes"];
export const DEFAULT_QUOTES_TAB_IDS = ["allQuotes", "openQuotes", "acceptedQuotes", "expiredQuotes"];
export const defaultOrdersTabNames: Record<string, string> = {
  allQuotes: "pages.account.quotes.all_quotes",
  allOrders: "pages.account.orders.all_orders",
  openQuotes: "pages.account.quotes.open_quotes",
  openOrders: "pages.account.orders.open_orders",
  acceptedQuotes: "pages.account.quotes.accepted_quotes",
  expiredQuotes: "pages.account.quotes.expired_quotes",
};
export const tabEmptyViewMessages: Record<string, string> = {
  allQuotes: "pages.account.quotes.no_quotes_message",
  allOrders: "pages.account.orders.no_orders_message",
  openQuotes: "pages.account.quotes.no_open_quotes_title",
  openOrders: "pages.account.orders.no_open_orders_title",
  acceptedQuotes: "pages.account.orders.no_accepted_quotes_title",
  expiredQuotes: "pages.account.quotes.no_expired_quotes_title",
};
export const ORDERS_QUOTES_STATUSES: Record<string, string> = {
  acceptedQuote: "pages.account.quotes.accepted_quote_status",
  notAcceptedQuote: "pages.account.quotes.not_accepted_quote_status",
  expiredQuote: "pages.account.quotes.expired_quote_status",
  open: "pages.account.orders.open_order_status",
  processed: "pages.account.orders.processed_order_status",
  inProcess: "pages.account.orders.in_process_order_status",
  invoiced: "pages.account.orders.invoiced_order_status",

  readyToAccept: "pages.account.quotes.ready_to_accept",
  placed: "pages.account.quotes.placed_status",
  ordered: "pages.account.quotes.ordered_status",
  requested: "pages.account.quotes.requested_status",
  pending: "pages.account.quotes.pending_status",
};

export const EUS_DOCUSIGN_CURRENCIES = new Set(["EUR", "GBP", "SEK"]);

export const EUS_DOCUSIGN_SENDER_NAMES = {
  GBP: "Thorlabs LTD.",
  SEK: "Thorlabs Sweden AB",
  EUR: {
    FRA: "Thorlabs SAS",
    SWE: "Thorlabs Sweden AB",
    default: "Thorlabs GmbH",
  },
} as const;

export const EUS_DOCUSIGN_SENDER_EMAIL = "dse@eumail.docusign.net";

// India orders (INR or EUR) are routed by shipping country to the Thorlabs India DocuSign account.
export const EUS_DOCUSIGN_INDIA = {
  countryCode: "IND",
  senderName: "Thorlabs India Private Limited",
  senderEmail: "dse_NA4@docusign.net",
} as const;
